import { Dialog } from "primereact/dialog";
import { useMemoryHitUptime } from "../../Hooks/Features/Inspectra/useMemoryHitUptime";
import { SkeletonContainer } from "../Loader/Loader";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
HighchartsMore(Highcharts);
Highcharts3D(Highcharts);
SolidGauge(Highcharts);

const MemoryUsage = ({ autopopData, projectChanged }) => {

    const widget = "memory";
    const { filterCount, loader, showFilter, setShowFilter, filterValues, setFilterValues, showPopup, setShowPopup, popupData, expand, setExpand, allMemoryOptions, serverWiseOptions, serverWisePopup, setServerWisePopup, serverWiseData, gaugeLoader, handleApplyFilters } = useMemoryHitUptime({ widget, projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Memory Usage by Service</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-widget-content inspectra-memory-usage">
                {loader ? <SkeletonContainer /> :
                    <div className="gap-4 d-flex flex-wrap" style={{ height: "100%" }}>
                        {allMemoryOptions.length > 0 && allMemoryOptions?.map((options, idx) => (
                            <div className="mb-2" key={idx} style={{ height: "100%", overflowY: "auto", borderRight: idx < allMemoryOptions?.length - 1 ? "1px solid #e5e5e5" : "auto" }}>
                                <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                                    style: {
                                        height: "auto",
                                    }
                                }} />
                            </div>
                        ))}
                        {!gaugeLoader ?
                            (serverWiseData?.api_data?.length > 0 &&
                                <div className="inspectra-widget-content position-relative" style={{ height: "100%", width: "20%" }}>
                                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={serverWiseOptions} containerProps={{
                                        style: {
                                            height: "100%",
                                        }
                                    }}
                                    />
                                </div>
                            ) :
                            <div style={{ height: "100%", width: "20%" }}><SkeletonContainer /></div>
                        }
                    </div>
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Memory Usage Filters">
                <div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Service:</div>
                            <MultiSelect options={autopopData?.service_name} placeholder="Service" value={filterValues?.service} onChange={(e) => setFilterValues((prev) => ({ ...prev, service: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'service', filterValues?.service, () => setFilterValues((prev) => ({ ...prev, service: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={autopopData?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => setFilterValues((prev) => ({ ...prev, service: [], server: [] }))}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); }} draggable={false} className="modal-large inspectra-grey-dialog" header="Memory Usage Details">
                <div>
                    <div className="service-error-list">
                        {popupData?.map((item, index) => (
                            <div key={index} className="service-error-item">
                                <div className="d-flex gap-5">
                                    <div><strong>Project:</strong> {item?.project_name}</div>
                                    <div><strong>Service Type:</strong> {item?.service_type}</div>
                                    <div><strong>Service:</strong> {item?.service_name}</div>
                                </div>
                                <div><strong>Server:</strong> {item?.server}</div>
                                <div><strong>Memory Usage:</strong> {item?.memory_usage}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={serverWisePopup?.show} onHide={() => { setServerWisePopup({ show: false, data: [] }); }} draggable={false} className="modal-medium inspectra-grey-dialog" header="Memory Usage Details - Server wise">
                <div>
                    <div className="service-error-list">
                        {serverWisePopup?.data?.map((item, index) => (
                            <div key={index} className="service-error-item">
                                <div className="d-flex gap-5">
                                    <div><strong>Project:</strong> {item?.project_name}</div>
                                    <div><strong>Server:</strong> {item?.server}</div>
                                </div>
                                <div><strong>Used RAM:</strong> {item?.used_ram}</div>
                                <div><strong>Free RAM:</strong> {item?.free_ram}</div>
                                <div><strong>Total RAM:</strong> {item?.total_ram}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Memory Usage by Server Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <div className="d-flex" style={{ height: "60vh" }}>
                        {allMemoryOptions.length > 0 && allMemoryOptions?.map((options, idx) => (
                            <div className="mb-2" key={idx} style={{ height: "100%", overflowY: "auto", borderRight: idx < allMemoryOptions?.length - 1 ? "1px solid #e5e5e5" : "auto" }}>
                                <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                                    style: {
                                        height: "auto",
                                    }
                                }} />
                            </div>
                        ))}
                        <div className="inspectra-widget-content position-relative" style={{ height: "100%", width: "30%" }}>
                            <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={serverWiseOptions} containerProps={{
                                style: {
                                    height: "100%",
                                }
                            }}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default MemoryUsage;